import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HasItems } from '../types';
import { CreateReportRequest, FullReportResponse, ReportResponse, ReportSharedResponse, ShareReportRequest } from '../types/reports';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private httpClient = inject(HttpClient);
  readonly apiHost = `${environment.apiBaseUrl}`;

  getUserReports(): Observable<HasItems<ReportResponse>> {
    const requestUrl = `${this.apiHost}/Reports`;
    return this.httpClient.get<HasItems<ReportResponse>>(requestUrl);
  }

  getReportById(reportId: string): Observable<FullReportResponse> {
    const requestUrl = `${this.apiHost}/Reports/${reportId}`;
    return this.httpClient.get<FullReportResponse>(requestUrl);
  }

  getReportShareHistory(reportId: string): Observable<HasItems<ReportSharedResponse>> {
    const requestUrl = `${this.apiHost}/Reports/${reportId}/History`;
    return this.httpClient.get<HasItems<ReportSharedResponse>>(requestUrl);
  }

  createReport(request: CreateReportRequest): Observable<ReportResponse> {
    const requestUrl = `${this.apiHost}/Reports`;
    return this.httpClient.post<ReportResponse>(requestUrl, request);
  }

  shareReport(reportId: string, request: ShareReportRequest): Observable<void> {
    const requestUrl = `${this.apiHost}/Reports/${reportId}/Share`;
    return this.httpClient.post<void>(requestUrl, request);
  }

  deleteReportById(reportId: string): Observable<void> {
    const requestUrl = `${this.apiHost}/Reports/${reportId}`;
    return this.httpClient.delete<void>(requestUrl);
  }
}
